
export default function ValuesSection() {
  const values = [
    {
      icon: "ri-heart-line",
      title: "Bienveillance",
      description: "Nous créons un environnement sûr et bienveillant où chacun peut s'épanouir sans jugement."
    },
    {
      icon: "ri-star-line",
      title: "Excellence",
      description: "Nous sélectionnons rigoureusement nos coachs pour garantir la plus haute qualité d'accompagnement."
    },
    {
      icon: "ri-team-line",
      title: "Accessibilité",
      description: "Nous rendons le coaching accessible à tous, quel que soit le niveau ou les objectifs de chacun."
    },
    {
      icon: "ri-lightbulb-line",
      title: "Innovation",
      description: "Nous utilisons les dernières technologies pour améliorer continuellement l'expérience de coaching."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Nos Valeurs
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ces valeurs guident chacune de nos actions et définissent notre approche du coaching
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${value.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{value.title}</h3>
              <p className="text-gray-600">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
